export const PP_PLAN_ID = 3249527;
export const PLUS_PLAN_ID = 4198888;
export const MENTORIA_PRIME_PLAN_ID = 2297215;
export const CLUB_PLAN_ID = 5549378;
export const MAE_NUTRIDA_PLAN_ID = 462895;

const PLANS_DATA = [
  {
    id: PP_PLAN_ID,
    name: 'PP',
    value: 3
  },
  {
    id: PLUS_PLAN_ID,
    name: 'Plus',
    value: 10
  },
  {
    id: MENTORIA_PRIME_PLAN_ID,
    name: 'Mentoria Prime',
    value: 20
  },
  {
    id: CLUB_PLAN_ID,
    name: 'Club',
    value: 100
  }
  /*   {
    id: 462895, //TODO: remove this plan
    name: 'Mae Nutrida',
    value: 20
  } */
]
const PLAN_IDS = PLANS_DATA.map(plan => plan.id)

export { PLAN_IDS, PLANS_DATA }
